import { render, staticRenderFns } from "./linkFailure.vue?vue&type=template&id=ec59cdc8&scoped=true"
import script from "./linkFailure.vue?vue&type=script&lang=js"
export * from "./linkFailure.vue?vue&type=script&lang=js"
import style0 from "./linkFailure.vue?vue&type=style&index=0&id=ec59cdc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec59cdc8",
  null
  
)

export default component.exports